import React, { useState, useEffect, useRef } from 'react';
import { FaMicrophone, FaVolumeUp, FaStop} from 'react-icons/fa';
import { PulseLoader , ClipLoader} from 'react-spinners'; 
import '../css/Chatbot.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Icon from '../assests/Spark_logo.png'

const Chatbot = ({ playerRef, id ,k}) => {
  const [message, setMessage] = useState('');
  const [conversation, setConversation] = useState([
    { text: 'Hello! How may I help you today?', isUser: false },
  ]);
  const [selectedLanguage, setSelectedLanguage] = useState('en-US');
  const [placeholder, setPlaceholder] = useState('Type your message');
  const [loading, setLoading] = useState(false); // Add loading state
  const [speechloading, setSpeechLoading] = useState(false); 
  const [isRecording, setIsRecording] = useState(false); // Recording state
  const mediaRecorderRef = useRef(null);
  const audioRef = useRef(null); // Create audio reference
  const audioChunksRef = useRef([]);
  const silenceTimer = useRef(null);
  const analyserRef = useRef(null);
  const chatbotBodyRef = useRef(null);
  const MIN_DECIBELS = -90; 
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    scrollToBottom();
  }, [conversation]);

  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value);
  };

  const scrollToBottom = () => {
    if (chatbotBodyRef.current) {
      chatbotBodyRef.current.scrollTop = chatbotBodyRef.current.scrollHeight;
    }
  };

  const handleInputChange = (event) => {
    setMessage(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSendMessage();
    }
  };

  // Audio Recording Functions
  const startRecording = () => {
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then(stream => {
        mediaRecorderRef.current = new MediaRecorder(stream);
        audioChunksRef.current = []; // Reset audio chunks

        mediaRecorderRef.current.ondataavailable = event => {
          audioChunksRef.current.push(event.data);
        };

        mediaRecorderRef.current.onstop = () => {
          const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
          sendAudioToServer(audioBlob);
        };

        mediaRecorderRef.current.start();
        console.log("recording started");
        setIsRecording(true);
        setPlaceholder('Speak now');

        const audioContext = new AudioContext();
        const audioStreamSource = audioContext.createMediaStreamSource(stream);
        analyserRef.current = audioContext.createAnalyser();
        analyserRef.current.minDecibels = MIN_DECIBELS;
        audioStreamSource.connect(analyserRef.current);

         // Start silence detection loop
        // resetSilenceTimer(); // Start silence timer
      })
      .catch(err => {
        console.error("Error accessing microphone:", err);
      });
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && isRecording) {
      mediaRecorderRef.current.stop();
      console.log("stopped recording");
      clearTimeout(silenceTimer.current);
      setIsRecording(false);
      setPlaceholder('Transcribing...');
    }
  };
  

  const handleRecording = () => {
    if (isRecording) {
      stopRecording();
    } else {
      startRecording();
    }
  };

  const sendAudioToServer = (audioBlob) => {
    const reader = new FileReader();
    reader.readAsDataURL(audioBlob);
    reader.onloadend = () => {
      const base64Audio = reader.result.split(',')[1]; 
      console.log("Encoded base64 audio: ", base64Audio);
      console.log("language selected: ", selectedLanguage);
  
      fetch('https://km0yl5vd0a.execute-api.ap-south-1.amazonaws.com/dev/stt-audio', {
        // fetch('https://7d3m1ntlhf.execute-api.ap-south-1.amazonaws.com/dev/stt-audio', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          audio: base64Audio,
          language: selectedLanguage, 
        }),
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}, body: ${response.body}`);
        }
        return response.json();
      })
      .then(data => {
        setMessage(data.transcript || '');
        setPlaceholder('Type your message');
      })
      .catch(error => {
        console.error('Error:', error);
        setPlaceholder('Type your message');
      });
    };
  };

  const handleSendMessage = async () => {
    if (message.trim() !== '') {
      setConversation(prev => [...prev, { text: message, isUser: true }]);
      setMessage('');
      setLoading(true); // Show loader
      try {
        const response = await fetch(`https://qc4u2xlmhc.execute-api.ap-south-1.amazonaws.com/dev/playlist-videobot/?id=${id}`, {
          // const response = await fetch(`https://7d3m1ntlhf.execute-api.ap-south-1.amazonaws.com/dev/videobot/?id=${id}&k=${k}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ prompt: message, language: selectedLanguage }),
        });
        if (response.ok) {
        const data = await response.json();
        console.log('API response data:', data);
        setConversation(prev => [...prev, { 
          text: data.body, 
          isUser: false, 
          isPlaying: false, // Initialize isPlaying state for each bot message
          speechloading: false // Initialize speechloading state for each bot message
        }]);
        } else {
          console.error('Response not OK:', response.statusText);
          setConversation(prev => [...prev, { text: 'An error occurred. Please try again.', isUser: false }]);
        }
      } catch (error) {
        console.error('Error:', error);
        setConversation(prev => [...prev, { text: 'An error occurred. Please try again.', isUser: false }]);
      } finally {
        setLoading(false); // Hide loader
      }
    }
  };

  
  const getSpeechResponse = async (text) => {
    const text1 = text.split("Click on a timestamp to jump to that point in the video.")[0];
    try {
      const response = await fetch('https://7d3m1ntlhf.execute-api.ap-south-1.amazonaws.com/dev/tts-elevenlabs', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ text: text1 }),
      });
  
      if (response.ok) {
        const contentType = response.headers.get('Content-Type');
  
        if (contentType && contentType.includes('application/json')) {
          const data = await response.json();
          let base64Audio = data.body.replace(/\s/g, '');
  
          // Properly pad the base64 string
          while (base64Audio.length % 4 !== 0) {
            base64Audio += '=';
          }
  
          const binaryString = atob(base64Audio);
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
  
          const blob = new Blob([bytes], { type: 'audio/mpeg' });
          const audioUrl = URL.createObjectURL(blob);
  
          // Set the audio in the ref
          audioRef.current = new Audio(audioUrl);
  
          audioRef.current.oncanplaythrough = () => {
            audioRef.current.play();
            setIsPlaying(true);
          };
  
          audioRef.current.onended = () => {
            setIsPlaying(false);
            URL.revokeObjectURL(audioUrl);
          };
  
          audioRef.current.onerror = (e) => {
            console.error('Audio playback error:', e);
            setIsPlaying(false);
          };
        } else if (contentType.includes('audio')) {
          const blob = await response.blob();
          const audioUrl = URL.createObjectURL(blob);
  
          // Set the audio in the ref
          audioRef.current = new Audio(audioUrl);
  
          audioRef.current.oncanplaythrough = () => {
            audioRef.current.play();
            setIsPlaying(true);
          };
  
          audioRef.current.onended = () => {
            setIsPlaying(false);
            URL.revokeObjectURL(audioUrl);
          };
  
          audioRef.current.onerror = (e) => {
            console.error('Audio playback error:', e);
            setIsPlaying(false);
          };
        }
      }
    } catch (error) {
      console.error('Error fetching or processing speech response:', error);
    } finally {
      setSpeechLoading(false);
    }
  };
  

  const seekTo = (timeString) => {
    if (playerRef.current) {
      const [hours, minutes, seconds] = timeString.split(':').map(Number);
      const totalSeconds = (hours * 3600) + (minutes * 60) + seconds;
      const timeMs = totalSeconds * 1000;
      console.log("Seeking to", timeMs, "ms");
      playerRef.current.seekTo(timeMs);
    }
  };

  const renderMessage = (msg, index) => {
    if (msg.isUser) {
      return <p>{msg.text}</p>;
    } else {
      const parts = msg.text.split('\n');
      let hasTimestamps = false;
      const renderedParts = [];
  
      parts.forEach((line, i) => {
        if (line.match(/^\d{1,2}:\d{2}:\d{2}/)) {
          if (!hasTimestamps) {
            hasTimestamps = true;
          }
          const [timestamp, ...rest] = line.split(' - ');
          const description = rest.join(' - ');
          renderedParts.push(
            <p key={i}>
              <a href="#" onClick={(e) => { e.preventDefault(); seekTo(timestamp); }}>
                {timestamp}
              </a>
              {' - ' + description}
            </p>
          );
        } else if (line.startsWith('-')) {
          renderedParts.push(<li key={i}>{line.substring(1).trim()}</li>);
        } else if (!line.startsWith('TIMESTAMPS:')) {
          renderedParts.push(<p key={i}>{line}</p>);
        }
      });
      // Function to handle audio play for the specific bot message
      const handleAudioPlay = async () => {
        
        const updatedConversation = [...conversation];
        updatedConversation[index].speechloading = true;
        setConversation(updatedConversation);
        
        await getSpeechResponse(msg.text); // Fetch TTS

        // Set the isPlaying state after loading completes
        updatedConversation[index].isPlaying = true;
        updatedConversation[index].speechloading = false;
        setConversation(updatedConversation);
      };

      const handleStopAudio = () => {
        if (audioRef.current) {
          audioRef.current.pause();
          const updatedConversation = [...conversation];
          updatedConversation[index].isPlaying = false;
          setConversation(updatedConversation);
        }
      };

      return (
        <div>
          {renderedParts}
          {/* Conditionally render volume button, loader, or stop icon */}
          <div>
            {msg.speechloading ? (
              <ClipLoader className='speech-ClipLoader-small' size={10} color="#30c484" />
            ) : msg.isPlaying ? (
              <button className="speech-stop-button" onClick={handleStopAudio}>
                <FaStop />
              </button>
            ) : (
              <button className="speech-button" onClick={handleAudioPlay}>
                <FaVolumeUp />
              </button>
            )}
          </div>
        </div>
      );
    }
  };

  return (
    <div className="chatbot-container">
      <div className="chatbot-header">
        <img className="icon" alt="icon" src={Icon} /> 
        KPOINT.AI
      </div>
      <div className="chatbot-body" ref={chatbotBodyRef}>
      {conversation.map((msg, index) => (
          <div key={index} className={`message ${msg.isUser ? 'user-message' : 'bot-message'}`}>
            {renderMessage(msg, index)}
          </div>
        ))}

        {/* Display the loader when loading */}
        {loading && (
          <div className="loader-container">
            <PulseLoader color="#30c484" size={7} />
          </div>
        )}
      </div>
      <div className="chatbot-footer">
        <input
          type="text"
          placeholder={placeholder}
          value={message}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          id="chatInput"
          name="chatInput"
        />
        <button onClick={handleSendMessage}> Send</button> 
        {/* <button id='startrecording' onClick={handleRecording}>
          <FaMicrophone/>
        </button> */}
        <select
          className="language-select"
          id="languageSelect"
          value={selectedLanguage}
          onChange={handleLanguageChange}   
        > 
          <option value="en-US">English</option>
          <option value="bn-IN">Bengali</option>
          <option value="gu-IN">Gujarati</option>
          <option value="hi-IN">Hindi</option>
          <option value="kn-IN">Kannada</option>
          <option value="ml-IN">Malayalam</option>
          <option value="mr-IN">Marathi</option>
          <option value="pa-Guru-IN">Punjabi</option>
          <option value="ta-IN">Tamil</option>
          <option value="te-IN">Telugu</option>
        </select> 
      </div>
    </div>
  );
};

export default Chatbot;